import { render, staticRenderFns } from "./yearPowerQuality.vue?vue&type=template&id=0fd0ea5e&scoped=true&"
import script from "./yearPowerQuality.vue?vue&type=script&lang=js&"
export * from "./yearPowerQuality.vue?vue&type=script&lang=js&"
import style0 from "./yearPowerQuality.vue?vue&type=style&index=0&id=0fd0ea5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0ea5e",
  null
  
)

export default component.exports